import { Fragment, useEffect, useRef } from 'react';
import { Preferences } from '@capacitor/preferences';


interface Props {
    storageRequestMode: string, SetStorageRequestMode: any,
    storageRequestParams: any, SetStorageRequestParams: any,
    storageRequestResultAction: any, SetStorageRequestResultAction: any
}

const PhoneStorageController: React.FC<Props> = ({ storageRequestMode, SetStorageRequestMode, storageRequestParams, SetStorageRequestParams, storageRequestResultAction, SetStorageRequestResultAction }) => {
    //refs
    const resultsRef = useRef<any>(null);
    
    //watchers
    useEffect(() => {
        //Preferences.clear();
    }, []);

    useEffect(() => {
        if (storageRequestParams.length > 0) {
            if (storageRequestMode.includes('get')) {
                GetFromPhoneStorage();
            } else if (storageRequestMode.includes('set')) {
                SetToPhoneStorage();
            } else if (storageRequestMode.includes('remove')) {
                RemoveFromPhoneStorage();
            }
        }
    }, [storageRequestMode, storageRequestParams]);

    //exe
    const GetFromPhoneStorage = async () => {
        try {
            const results: any = {};
            for (let i = 0; i < storageRequestParams.length; i++) {
                const param = storageRequestParams[i];
                const result = await Preferences.get({ key: param }).then((res) => { return res.value });
                if (result != null)
                    results[param.split(':')[1]] = result;
                // else
                //     throw 'getFromPhoneStorageErr: unfound';
            }
            SetStorageRequestParams([]);
            resultsRef.current = results;
            SetStorageRequestResultAction(() => ReturnAndWipeResult);
        } catch {

        }
    }
    const SetToPhoneStorage = async () => {
        //await Preferences.set({ key: 'id', value: user.id });
        storageRequestParams.map(async (param: any) => {
            await Preferences.set({ key: param[0], value: param[1] });
        });
        SetStorageRequestParams([]);
    }
    const RemoveFromPhoneStorage = async () => {
        storageRequestParams.map(async (param: string) => {
            await Preferences.remove({ key: param });
        });
        SetStorageRequestParams([]);
    }
    const ReturnAndWipeResult = () => {
        //return the result and auto cleared the result when called
        setTimeout(() => {
            SetStorageRequestResultAction(null);
            resultsRef.current = null;
        }, 0);
        return resultsRef.current;
    }

    return (<Fragment />);
};

export default PhoneStorageController;